var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCalendarLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Calendar-Logo.wine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14717",
    "data-name": "Path 14717",
    d: "M47.474,18H18V47.474H47.474Z",
    transform: "translate(-4.737 -4.737)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14718",
    "data-name": "Path 14718",
    d: "M58,71.263,71.263,58H58Z",
    transform: "translate(-15.263 -15.263)",
    fill: "#ea4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14719",
    "data-name": "Path 14719",
    d: "M71.263,18H58V47.474H71.263Z",
    transform: "translate(-15.263 -4.737)",
    fill: "#fbbc04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14720",
    "data-name": "Path 14720",
    d: "M47.474,58H18V71.263H47.474Z",
    transform: "translate(-4.737 -15.263)",
    fill: "#34a853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14721",
    "data-name": "Path 14721",
    d: "M0,58v8.842a4.42,4.42,0,0,0,4.421,4.421h8.842V58Z",
    transform: "translate(0 -15.263)",
    fill: "#188038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14722",
    "data-name": "Path 14722",
    d: "M71.263,13.263V4.421A4.42,4.42,0,0,0,66.842,0H58V13.263Z",
    transform: "translate(-15.263)",
    fill: "#1967d2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14723",
    "data-name": "Path 14723",
    d: "M42.737,0H4.421A4.42,4.42,0,0,0,0,4.421V42.737H13.263V13.263H42.737Z",
    fill: "#4285f4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14724",
    "data-name": "Path 14724",
    d: "M25.391,43.022a5.7,5.7,0,0,1-2.281-3.268L25.667,38.7a3.882,3.882,0,0,0,1.216,2.056,3.133,3.133,0,0,0,2.093.726,3.226,3.226,0,0,0,2.155-.763,2.436,2.436,0,0,0,.9-1.942,2.408,2.408,0,0,0-.951-1.967,3.687,3.687,0,0,0-2.38-.763H27.225V33.517h1.326a3.232,3.232,0,0,0,2.067-.663,2.187,2.187,0,0,0,.84-1.816,2.007,2.007,0,0,0-.752-1.639,2.913,2.913,0,0,0-1.9-.615,2.561,2.561,0,0,0-1.791.6,3.525,3.525,0,0,0-.965,1.477l-2.531-1.054a5.62,5.62,0,0,1,1.853-2.516A5.344,5.344,0,0,1,28.824,26.2a6.3,6.3,0,0,1,2.793.6,4.778,4.778,0,0,1,1.942,1.665,4.25,4.25,0,0,1,.7,2.391,3.917,3.917,0,0,1-.652,2.292A4.494,4.494,0,0,1,32,34.589v.151a4.867,4.867,0,0,1,2.056,1.6,4.2,4.2,0,0,1,.8,2.579A4.827,4.827,0,0,1,34.1,41.6,5.283,5.283,0,0,1,32,43.457a6.632,6.632,0,0,1-3.017.678A6.246,6.246,0,0,1,25.391,43.022ZM41.1,30.334l-2.807,2.03-1.4-2.129L41.922,26.6h1.931V43.737H41.1Z",
    transform: "translate(-6.082 -6.895)",
    fill: "#4285f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendarLogo);
export default __webpack_public_path__ + "static/media/google_calendar_logo.5d67f5e22745b1d427bfb9893c2dbe62.svg";
export { ForwardRef as ReactComponent };